const crossfadeDurationMs = 150;
const wrapper = "_35sw65h4d";
const toggleGroup = "_35st7en6dy";
const transitionWrapper = "_35st36pm02";
const content = "_35sc1cyjje1";

export { content, crossfadeDurationMs, toggleGroup, transitionWrapper, wrapper };
import "./container.facit.style.linaria.module.css";
//# sourceMappingURL=container.facit.style.js.map
